"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _styles = require("@mui/styles");

var _iconsMaterial = require("@mui/icons-material");

var _root = require("../../store/root.selector");

var _gift = require("../../store/gift/gift.actions");

var _constants = require("../../constants");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      padding: '28px 0 4px 0'
    },
    avatar: {
      border: "4px solid ".concat(palette.green.fruitSalad80),
      fontSize: '62px',
      width: '62px',
      height: '62px'
    },
    gift: {
      display: 'flex',
      flexDirection: 'column',
      padding: spacing(0, 2),
      flex: 1
    },
    title: {
      fontSize: '0.75rem',
      fontWeight: 700,
      lineHeight: '133%',
      color: palette.grey.main,
      paddingTop: spacing(1)
    },
    label: {
      marginTop: 8,
      fontSize: '1.5rem',
      lineHeight: '133%',
      color: palette.primary.main
    },
    quantity: {
      display: 'flex',
      gap: 8,
      paddingTop: 24
    },
    field: {
      width: 86
    },
    input: {
      paddingRight: 0
    },
    closeButton: {
      padding: 0
    },
    close: {
      fontSize: '1rem',
      color: palette.primary.main
    },
    pcs: {
      paddingTop: 8,
      color: palette.primary.main
    }
  };
});

var isValidQuantity = function isValidQuantity(value) {
  return /^[0-9]+$/.test(value) && (0, _ramda.gte)(Number(value), 0);
};

var GiftQuantity = function GiftQuantity() {
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var quantity = (0, _reactRedux.useSelector)(_root.getGiftQuantity);
  var giftProposedProducts = (0, _reactRedux.useSelector)(_root.getGiftProposedProducts);
  var giftName = (0, _ramda.pathOr)('', ['0', 'name'], giftProposedProducts);
  var image = (0, _ramda.pathOr)('', ['0', 'image'], giftProposedProducts);
  var handleClearQuantity = (0, _react.useCallback)(function () {
    dispatch((0, _gift.updateGiftQuantity)(''));
  }, [dispatch]);
  var handleOnChange = (0, _react.useCallback)(function (e) {
    var value = e.target.value;

    if (isValidQuantity(value)) {
      dispatch((0, _gift.updateGiftQuantity)(Number(value)));
    } else if (!value) {
      handleClearQuantity();
    }
  }, [dispatch, handleClearQuantity]);
  (0, _react.useEffect)(function () {
    return function () {
      return handleClearQuantity();
    };
  }, [handleClearQuantity]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: classes.avatar,
    alt: "",
    src: image,
    "data-testid": "GiftQuantity.GiftImg"
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.gift
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.title,
    "data-testid": "GiftQuantity.HowManyPieces"
  }, "How many pieces to send?"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.label,
    "data-testid": "GiftQuantity.GiftName"
  }, giftName)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.quantity
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    fullWidth: true,
    label: "Quantity",
    variant: "outlined",
    value: quantity,
    classes: {
      root: classes.field
    },
    error: !quantity,
    autoComplete: "off",
    onChange: handleOnChange,
    InputProps: {
      classes: {
        input: classes.input
      },
      inputProps: {
        maxLength: 3,
        'data-testid': 'GiftQuantity.QuantityField'
      },
      endAdornment: quantity > _constants.DEFAULT_GIFT_QUANTITY && /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
        className: classes.closeButton,
        onClick: handleClearQuantity,
        "data-testid": "GiftQuantity.CloseButton"
      }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.Close, {
        className: classes.close
      })))
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.pcs
  }, "pcs"))), !quantity && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    error: true
  }, "Quantity must be equal or greater than 1.")));
};

var _default = GiftQuantity;
exports.default = _default;